module.exports = __webpack_public_path__ + "media/assets/images/payments/amex-4cd3ee8da6e6d9de5b4dc844add9118c.png";